module.exports = {
  changeEmail: 'Sim, mudar a direcão de e-mail',
  dontChangeEmail: 'Não, manter o e-mail atual',
  yes: 'Sim',
  no: 'Não',
  'next-step': 'Seguinte',
  'last-step': 'Receba ofertas personalizadas',
  'go-back': 'Voltar',
  understood: 'Entendido!',
  'company-placeholder': 'Empresa',
  'company-label': 'Nome da empresa',
  'address-placeholder': 'Rua, número e andar',
  address_no_number_placeholder: 'Rua sem número',
  'address-label': 'Morada',
  'address-street-number-label': 'Número',
  'address-street-number-placeholder': '10',
  'address-no-street-number-label': 'Sem número',
  'address-not-found': 'Morada não identificada',
  'address-no-match': 'A morada inserida não existe',
  'address-choose-from': 'Escolha uma morada',
  'address-invalid': 'A morada não é válida',
  'address-missing-street-number': 'Introduza o número',
  'company-autocomplete-label': '',
  address_alert: 'Inseriu a morada correta?',
  address_missing_city: 'Introduza a localidade',
  'zip-label': 'Código postal',
  'zip-does-not-exist': 'O código postal inserido não existe',
  zip_placeholder: '01234',
  'name-label': 'Nome completo',
  'first-name': 'Nome',
  'last-name': 'Apelido',
  'date-format': 'ddmmaa',
  'date-label': 'Data',
  'birthdate-label': 'Data de nascimento',
  'national-identity-label': 'Cartão do cidadão ou NIE',
  'national-identity-placeholder': 'Todos os números e letras',
  'national-identity-invalid': 'O número de indentificação não é válido',
  'national-identity-identical':
    'O número de indentificação do 1º titular e 2º titular não pode ser o mesmo',
  'bank-account-label': 'Número da conta bancária',
  'measuring-id-invalid': 'O código do contador não é válido',
  'bank-account-placeholder': '24 cifras',
  'bank-account-invalid': 'O número da conta não é válido',
  'organization-identity-label': 'NIF da empresa',
  'organization-identity-placeholder': 'Todos os números e letras',
  'organization-identity-invalid': 'O NIF da empresa não é válido',
  'date-invalid': 'A data não é válida',
  'name-placeholder': 'Nome completo',
  'first-name-placeholder': 'Nome',
  'last-name-placeholder': 'Apelido',
  'name-invalid': 'O nome não é válido',
  'email-alert-message': 'Inseriu a direção de e-mail correta?',
  'email-label': 'Correio eletrónico',
  'email-placeholder': 'Correio eletrónico',
  'email-does-not-exist': 'A direção de e-mail não existe',
  'email-invalid': 'A direção de e-mail não é válida',
  email_did_you_mean: 'Quería dizer',
  'comment-label': 'Informação adicional',
  'comment-placeholder':
    'Alguma informação que deseje adicionar sobre si, o que precisa ou algo que devamos saber para lhe oferecer um melhor serviço',
  'phone-alert-message': 'Inseriu o número de telefone correto?',
  'phone-label': 'Número de telefone',
  'phone-invalid': 'O número de telefone não é válido',
  'phone-must-begin-with-+': 'O número de telefone deve começar com o símbolo +',
  'phone-foreign': 'Número de telefone estrangeiro',
  'phone-placeholder': '123456789',
  'phone-foreign-placeholder-prefix': '351',
  'error-x-numbers': 'Deve conter --x-- números',
  'error-x-letters': 'Deve conter --x-- letras',
  'error-min-x-letters': 'Deve conter pelo menos --x-- letras',
  'error-min-x-numbers': 'Deve conter pelo menos --x-- números',
  'error-max-x-numbers': 'Deve conter máximo --x-- números',
  'error-inbetween-numbers': 'Deve conter entre --x-----y-- números',
  'error-must-consist-of-x-letters': 'Deve conter --x-- letras',
  'error-mandatory': 'Campo obrigatório',
  'error-choose': 'Escolha pelos menos --x-- alternativa(s)',
  'error-min-age': 'Esta oferta é exclusivamente para pessoas maiores de --x-- anos',
  'error-must-accept': 'Tem que aceitar',
  privacy:
    'Protegemos a sua privacidade: Os seus dados são criptografados e enviados ao servidor através de uma conexão segura.',
  close: 'Fechar',
  error_radio_button: 'Escolha uma opção',
  invalid_day: 'O dia inserido não é válido',
  invalid_day_in_month: 'O dia não é válido para o mês inserido',
  invalid_month: 'O mês inserido não é válido',
  invalid_year: 'O ano inserido não é válido',
  invalid_input: 'Introduza todos os números e letras sem espaços',
  invalid_country: 'O país não é válido',
  label_birthdate: 'Data de nascimento',
  label_date: 'Dia',
  label_month: 'Mês',
  label_year: 'Ano',
  locale: '',
  missing_date: 'Introduza o dia',
  missing_month: 'Introduza o mês',
  missing_year: 'Introduza o ano',
  'datepicker-button': 'Selecione a data',
  email_wrong_user_account: 'Tem a certeza que a conta de usuário de correio eletrónico é correta?',
  email_wrong_email_address: 'Tem a certeza que a direção de correio eletrónico é correta?',
  not_valid_state: 'Indique um distrito',
  placeholder_state_dropdown: 'Distrito',
  label_state_dropdown: 'Distrito',
  no_future_dates: 'A data deve ser anterior à data atual',
  date_warning: 'Comprove que a data seja correta',
  'go-back-wizard': '',
  'next-step-wizard': '',
  step: '',
  off: '',
  not_valid_municipality: '',
  'sms-verification-label': '',
  'sms-verification-tinyLabel': '',
  'sms-verification-error-message': '',
  'sms-verification-code-not-received-first': 'Ainda não recebeu um código? ',
  'sms-verification-code-not-received-link': 'Clique aqui',
  'sms-verification-code-not-received-last': ' para reenviar.',
  'sms-verification-code-is-sent-again': 'Reenviámos o código.',
  'sms-verification-code-retry-error': 'Aguarde 30 segundos antes de tentar novamente.',
  'leazard-two-factor-header': 'Já está quase',
  'leazard-two-factor-help-text':
    'Enviámos-lhe um SMS com um código através do número +47 59 44 45 00 para confirmar o seu número. Não lhe enviaremos mais mensagens.',
  'leazard-loading-text': 'Processando os seus dados',
  'leazard-two-factor-submit': 'Enviado',
  'leazard-two-factor-label': 'Introduza o código para confirmar.',
  'recaptcha-disclaimer': 'Este site está protegido pelo reCAPTCHA.',
};
